import { Alert, Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

export default function AppConfirmationLabel() {
	const { entity } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack sx={{ alignItems: "center", my: 4 }}>
			<Alert severity='info' sx={{ maxWidth: 330 }}>
				{translate("connect_panel.confirm_app", { entity: entity?.name })}
			</Alert>
		</Stack>
	);
}
